export const adjustForMultiplier = (
  value: string | undefined,
  unit: string | undefined,
): string => {
  if (!value || !unit) return "";
  return unit === "SALARY_MULTIPLIER"
    ? (Number(value) * 100).toString()
    : value;
};
